module.exports = __webpack_public_path__ + "img/amenity-logo.ba1f6d50.svg";